import { render, staticRenderFns } from "./addSubAccountDialog.vue?vue&type=template&id=02a780a6&scoped=true&"
import script from "./addSubAccountDialog.vue?vue&type=script&lang=js&"
export * from "./addSubAccountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a780a6",
  null
  
)

export default component.exports